import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Constant } from 'app/core/common/constant';
import { HttpProvider } from 'app/core/common/http-provider.service';
import { PagingConfig } from 'app/core/feature/rest/pagingConfig';
import { ExpenseDetail } from 'app/modules/expense/model/expense-card.model';
import { FilterData } from '../model/filter-data.model';

@Injectable({
  providedIn: 'root',
})
export class ExpenseService extends HttpProvider {
  //#region Reports

  //#region Varaible
  expenseCardData: ExpenseDetail = new ExpenseDetail();

  private readonly expenseTypeEndpoint = '/expense_type/';
  private readonly expenseBucketEndpoint = '/expense_bucket/';
  private readonly reportEndpoint = '/report/';
  private readonly addExpenseReportEndpoint = '/add_expense_report/';
  private readonly removeExpenseReportEndpoint = '/remove_expense_report/';
  private readonly expenseCommentEndpoint = '/expense_transaction_log/';
  private readonly expenseHistoryEndpoint = '/expense_history/';
  private readonly moneyRequestEndpoint = '/money_request/';
  private readonly moneyRequestHistoryEndpoint = '/money_request_log/';
  private readonly addExpenseAttachmentEndpoint =
    '/expense_transaction/upload/';
  private readonly expenseTransactionEndpoint = '/expense_transaction/';
  private readonly expenseBucketDashboardEndpoint =
    '/expense_bucket_dashboard/';
  private readonly userExpenseBudgetEndpoint = '/user_expense_budget/';
  private readonly expenseReversalEndpoint = '/expense_reversal/';
  private readonly filePdfEndpoint = '/generate_pdf/';
  private readonly validateExpenseAmountEndpoint = '/partial-validate-expense/';
  private readonly resetLoaderEndPoint = 'reset-loader-object';
  private readonly getReportPdfEndpoint = '/pdf_report_generate/';
  private readonly partialExpenseRejectionEndpoint = '/expense_resubmission/';
  private readonly permanentExpenseRejectionEndpoint = '/expense_rejection/';
  private readonly expenseTypeWisePolicyEndpoint = '/user_policy/';
  private readonly mainExpenseTypeDropdownEndpoint =
    '/main_expense_type_dropdown/';
  private readonly exportExpenseBucketsEndpoint = '/new_expense_bucket_stats/';
  private readonly moneyRequestAttachmentEndpoint =
    '/money_request_attachment/';
  private readonly exportExpenseBucketDataEndpoint =
    '/expense_bucket_excel_export/';
  private readonly reportOverMailEndpoint = '/expense_report_pdf_via_email/';
  private readonly expenseListWebEndpoint = '/expense_list_web/';
  private readonly expenseDetailWebEndpoint = '/expense_detail_web/';
  private readonly reportListWebEndpoint = '/report_list_web/';
  private readonly reportDetailWebEndpoint = '/report_detail_web/';
  private readonly expenseTaxEndpoint = '/expense_tax/';
  private readonly editExpenseTypeChangeEndpoint = '/change_expense_type/';
  private readonly getReportCsvEndpoint = '/report_expense_types_export/';
  private readonly reportExternalRefEndpoint = '/report_external_refernce/';
  private readonly reportLogEndpoint = '/report_log/';
  private readonly userLimitEndpoint = '/user_credit_limit/';
  private readonly userWiseExpenseBucketEndpoint = '/user_expense_buckets/';
  private readonly expenseBucketBreakUpEndpoint =
    '/expense_breakup_bucketwise/';
  private readonly unassignExpenseBucketEndpoint =
    '/unassign_user_from_bucket/';
  private readonly enableDisableExpenseBucketEndpoint =
    '/enable_disable_expense_bucket/';
  private readonly VendorEndPoint = '/vendor/';
  private readonly importBucketEndPoint = '/expense-bucket/bulk-import/';
  private readonly importBucketUserEndPoint = '/expense_bucket_user_bulk_import/';
  private readonly importBucketUserTemplateEndPoint = '/expense_bucket_user_bulk_import/template/';
  private readonly vendorAddressDropdownEndpoint = '/vendor_address_dropdown/';
  private readonly orgAddressDropdownEndpoint = '/org_address_dropdown/';
  private readonly vendorQuickCreateEndpoint = '/vendor/vendor_quick_create/';
  private readonly partialMoneyRequest = '/partial_money_request/';
  private readonly submitForApprovalEndpoint = '/workflows/submit-for-approval/'
  private readonly processApprovalRequestEndpoint = '/workflows/process-approval-request/'
  private readonly rejectApprovalRequestEndpoint = '/workflows/process-reject-request/'
  //#endregion
  //#region BehaviorSubjects
  expenseCardSelectionSubject = new BehaviorSubject<ExpenseDetail>(
    this.expenseCardData
  );
  //#endregion
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  resetLoader() {
    return this.get(this.resetLoaderEndPoint);
  }

  //#region EXPENSE TYPE
  getAllExpenseTypeList() {
    return this.get(this.expenseTypeEndpoint);
  }

  saveExpenseType(value: any) {
    if (value.id == 0) {
      return this.post(this.expenseTypeEndpoint, value);
    } else {
      return this.put(this.expenseTypeEndpoint + value.id + '/', value);
    }
  }

  deleteExpenseType(id: number) {
    return this.delete(this.expenseTypeEndpoint + id.toString() + '/');
  }
  //#endregion

  //#region
  getExpenseBucketList(role = '', pagingConfig?: any, search: string = '') {
    const queryParams = {
      role: role,
      page_size: pagingConfig.pageSize,
      page: pagingConfig.pageNumber,
      search: search,
      expense_bucket_view: true,
    };
    return this.get(this.expenseBucketEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getExpenseBucketById(pk) {
    return this.get(this.expenseBucketEndpoint + pk + '/', true);
  }

  saveExpenseBucket(value: any) {
    if (value.id != null && value.id != 0) {
      return this.put(this.expenseBucketEndpoint + value.id + '/', value, true);
    } else {
      return this.post(this.expenseBucketEndpoint, value, true);
    }
  }

  deleteExpenseBuckete(id: number) {
    return this.delete(this.expenseBucketEndpoint + id.toString() + '/');
  }

  //#endregion

  //#region EXPENSE TRANSCATION
  getExpenseTranscationById(id) {
    return this.get(this.expenseTransactionEndpoint + id + '/');
  }
  getUserExpenseTranscation(
    role,
    filteredData: FilterData,
    pagingConfig?: any
  ) {
    if (
      role.toLowerCase() != Constant.RoleName.Admin.toLowerCase() &&
      role.toLowerCase() != Constant.RoleName.Finance.toLowerCase()
    ) {
      const queryParams = {
        page_size: pagingConfig.pageSize,
        page: pagingConfig.pageNumber,
        for_user: true,
        search_term: filteredData.search_term,
        from_date: filteredData.from_date,
        to_date: filteredData.to_date,
      };
      return this.get(this.expenseTransactionEndpoint, true, {
        params: this.toHttpParams(queryParams),
      });
    } else {
      const queryParams = {
        page_size: pagingConfig.pageSize,
        page: pagingConfig.pageNumber,
        search_term: filteredData.search_term,
        from_date: filteredData.from_date,
        to_date: filteredData.to_date,
      };
      return this.get(this.expenseTransactionEndpoint, true, {
        params: this.toHttpParams(queryParams),
      });
    }
  }

  saveExpenseTranscation(value: any) {
    if (value.id != 0) {
      return this.put(this.expenseTransactionEndpoint + value.id + '/', value);
    } else {
      return this.post(this.expenseTransactionEndpoint, value);
    }
  }

  getExpenseTranscationComment(id) {
    const queryParams = {
      expense_transaction_id: id,
    };
    return this.get(this.expenseCommentEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  addExpenseComment(value: any) {
    return this.post(this.expenseCommentEndpoint, value);
  }
  addExpenseToReport(value: { report_id: number; expense_ids: number[] }) {
    return this.post(this.addExpenseReportEndpoint, value);
  }

  removeExpenseFromReport(value: { report_id: number; expense_ids: number[] }) {
    return this.post(this.removeExpenseReportEndpoint, value);
  }

  uploadExpensefile(files: any) {
    return this.post(this.addExpenseAttachmentEndpoint, files);
  }

  getExpenseFile(id: any) {
    return this.get(this.addExpenseAttachmentEndpoint + id + '/');
  }

  deleteAttachment(expense: any) {
    return this.delete(this.addExpenseAttachmentEndpoint, expense);
  }

  reversalExpense(data: any) {
    return this.post(this.expenseReversalEndpoint, data);
  }

  //#endregion

  //#region Reports
  saveReport(value: any) {
    return this.post(this.reportEndpoint, value);
  }

  updateReport(value: any) {
    return this.put(this.reportEndpoint + `${value.id}/`, value);
  }

  getAllReport(queryParams) {
    return this.get(this.reportEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }
  //#endregion
  //#region

  getMoneyRequestList(queryParams: any) {
    return this.get(this.moneyRequestEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getMoneyRequestById(id: number) {
    return this.get(this.moneyRequestEndpoint + `${id}/`, true);
  }

  /**
   * Re-run only the bank payout for a money request whose transfer the bank
   * refused. The approval flow is already complete and is left untouched.
   */
  retryMoneyRequestBankTransfer(id: number) {
    return this.post(
      this.moneyRequestEndpoint + `${id}/retry_bank_transfer/`,
      {},
      true
    );
  }

  updateMoneyRequestStatus(id: number, value: any, matrix = false) {
    if (matrix) {
      if (value.approved || value.verified) {
        const payload = {
          "document_id": value.id,
          "document_type": "MONEY_REQUEST",
        };
        return this.post(this.processApprovalRequestEndpoint, payload, true);
      } else if (value.rejected) {
        const payload = {
          "document_id": value.id,
          "document_type": "MONEY_REQUEST",
          "remarks": value.reason,
        };
        return this.post(this.rejectApprovalRequestEndpoint, payload, true);
      }
    }
    else {
      return this.put(this.moneyRequestEndpoint + id + '/', value);
    }
  }

  getMoneyRequestHistory(id: number) {
    const queryParams = {
      money_request_id: id,
    };
    return this.get(this.moneyRequestHistoryEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getExpenseBucketDashboard() {
    const queryParams = {
      for_user: 'True',
    };
    return this.get(this.expenseBucketDashboardEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getUserBudgetData(selectedBucketId: any) {
    return this.get(this.userExpenseBudgetEndpoint + selectedBucketId + '/');
  }
  //#endregion
  //#region
  setSelectedCard(data: ExpenseDetail) {
    this.expenseCardSelectionSubject.next(this.expenseCardData);
    this.expenseCardData = data;
  }
  //#endregion

  downloadfile(data) {
    return this.get(this.filePdfEndpoint, data);
  }

  validateAmount(data) {
    return this.post(this.validateExpenseAmountEndpoint, data);
  }

  getDataByEndpoint(routes) {
    return this.getExternalEndpoint(routes);
  }

  getReportPDF(id, attachment = 0): any {
    const params: { [param: string]: string | number | boolean } = {
      report_id: id,
      attachment: attachment,
    };
    return this.getBlob(this.getReportPdfEndpoint, true, params);
  }

  partiallyRemoveExpense(value: {
    comment: string;
    expense_transaction_ids: number[];
  }) {
    return this.post(this.partialExpenseRejectionEndpoint, value);
  }
  permanentRemoveExpense(value: {
    comment: string;
    expense_transaction_ids: number[];
  }) {
    return this.post(this.permanentExpenseRejectionEndpoint, value);
  }

  getExpenseTypeWisePolicy(selectedCategory: any) {
    const queryParams = {
      category_id: selectedCategory,
    };
    return this.get(this.expenseTypeWisePolicyEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getMainExpenseType() {
    return this.get(this.mainExpenseTypeDropdownEndpoint, false);
  }

  getExpenseBucketExcel(role = '') {
    const query_params = {
      export_type: 'excel',
      role: role,
    };
    return this.getBlob(this.exportExpenseBucketsEndpoint, true, query_params);
  }

  getMoneyRequestAttachment(id: number) {
    return this.get(this.moneyRequestAttachmentEndpoint + id + '/');
  }

  getExpenseBucketDataExcel(data: any) {
    return this.exportCSV(this.exportExpenseBucketDataEndpoint, data);
  }

  /**
   * Queues a CSV export of the expenses booked to one bucket.
   * `body` may carry { start_date, end_date } as 'YYYY-MM-DD'; omit it for the
   * server's default window. The file is emailed rather than streamed, so the
   * response is a 202 carrying { message, start_date, end_date, clamped,
   * max_window_months } — not a file blob.
   */
  exportBucketExpenses(bucketId: number, body: any = {}) {
    return this.post(
      `${this.expenseBucketEndpoint}${bucketId}/export_expenses/`,
      body
    );
  }

  getReportOverEmailEndPoint(id) {
    const queryParams = {
      report_id: id,
    };
    return this.get(this.reportOverMailEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getUserExpenseList(role, filteredData: FilterData, pagingConfig?: any) {
    if (
      role.toLowerCase() != Constant.RoleName.Admin.toLowerCase() &&
      role.toLowerCase() != Constant.RoleName.Finance.toLowerCase() &&
      role.toLowerCase() != Constant.RoleName.Manager.toLowerCase()
    ) {
      const queryParams: any = {
        page_size: pagingConfig.pageSize,
        page: pagingConfig.pageNumber,
        for_user: true,
        search_term: filteredData.search_term,
        from_date: filteredData.from_date,
        to_date: filteredData.to_date,
        status_in: filteredData.status,
        expense_bucket: filteredData.expense_bucket,
      };
      if (filteredData.for_credit_reversals) {
        queryParams.for_credit_reversals = true;
      }
      if (filteredData.report_id__isnull) {
        queryParams.report_id__isnull = true;
      }
      if (filteredData.added_by) {
        queryParams.added_by = filteredData.added_by;
      }
      return this.get(this.expenseListWebEndpoint, true, {
        params: this.toHttpParams(queryParams),
      });
    } else {
      const queryParams: any = {
        page_size: pagingConfig.pageSize,
        page: pagingConfig.pageNumber,
        search_term: filteredData.search_term,
        from_date: filteredData.from_date,
        to_date: filteredData.to_date,
        status_in: filteredData.status,
        expense_bucket: filteredData.expense_bucket,
      };
      if (filteredData.for_credit_reversals) {
        queryParams.for_credit_reversals = true;
      }
      if (filteredData.report_id__isnull) {
        queryParams.report_id__isnull = true;
      }
      if (filteredData.for_user) {
        queryParams.for_user = true;
      }
      if (filteredData.added_by) {
        queryParams.added_by = filteredData.added_by;
      }
      return this.get(this.expenseListWebEndpoint, true, {
        params: this.toHttpParams(queryParams),
      });
    }
  }

  getExpenseDetailById(id: number) {
    return this.get(this.expenseDetailWebEndpoint + id + '/', true);
  }

  getAllReportList(role, searchTerm: string, pagingConfig?: PagingConfig) {
    let queryParams;
    if (
      role.toLowerCase() != Constant.RoleName.Admin.toLowerCase() &&
      role.toLowerCase() != Constant.RoleName.Finance.toLowerCase()
    ) {
      queryParams = {
        page_size: pagingConfig.pageSize,
        page: pagingConfig.pageNumber,
        for_user: true,
        search_term: searchTerm,
      };
    } else {
      queryParams = {
        page_size: pagingConfig.pageSize,
        page: pagingConfig.pageNumber,
        search_term: searchTerm,
      };
    }
    return this.get(this.reportListWebEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getReportDetailsById(id, isApprovalView?) {
    const query_params = {
      is_approval_view: isApprovalView,
    }
    return this.get(this.reportDetailWebEndpoint + id + '/', true, {
      params: this.toHttpParams(query_params),
    });
  }

  getExpenseTaxData(expenseId: number) {
    return this.get(this.expenseTaxEndpoint + `${expenseId}/`);
  }

  saveExpeneTax(id, data) {
    return this.put(this.expenseTaxEndpoint + `${id}/`, data);
  }

  editExpenseType(data) {
    return this.put(
      this.editExpenseTypeChangeEndpoint + `${data.id}/`,
      data,
      true
    );
  }

  getReportCSVBreakup(reportId) {
    const query_params = {
      report_id: reportId,
    };
    return this.getBlob(this.getReportCsvEndpoint, true, query_params);
  }

  saveExternalReference(data) {
    return this.put(this.reportExternalRefEndpoint + `${data.id}/`, data);
  }

  getReportLog(id) {
    return this.get(this.reportLogEndpoint + `${id}/`);
  }

  getUserCreditLimit(id) {
    return this.get(this.userLimitEndpoint + `${id}/`);
  }

  getUserWiseExpenseBucket(role) {
    const query_params = {
      role: role,
    };
    return this.get(this.userWiseExpenseBucketEndpoint, true, {
      params: this.toHttpParams(query_params),
    });
  }

  getExpenseBucketOverviewData(id, from_date, to_date, role) {
    return this.get(
      this.expenseBucketBreakUpEndpoint +
      `${id}/${role}/${from_date}/${to_date}/1/`
    );
  }

  unassignExpenseBucket(data) {
    return this.put(
      this.unassignExpenseBucketEndpoint + `${data.expense_bucket_id}/`,
      data,
      true
    );
  }

  setExpenseBucketStatus(data) {
    return this.put(
      this.enableDisableExpenseBucketEndpoint + `${data.id}/`,
      data,
      true
    );
  }


  getVendorById(vendorId: number) {
    return this.get(this.VendorEndPoint + `${vendorId}/`, false);
  }

  vendorPartialSaving(userId: number, data) {
    return this.patch(this.VendorEndPoint + `${userId}/`, data, true);
  }

  updateExpenseInvoiceDetails(expenseId: number, data: any) {
    return this.patch(this.expenseTransactionEndpoint + `${expenseId}/`, data, true);
  }

  getVendorAddressDropdown(vendorId: number) {
    return this.get(this.vendorAddressDropdownEndpoint, false, {
      params: this.toHttpParams({ vendor_id: vendorId }),
    });
  }

  getOrgAddressDropdown() {
    return this.get(this.orgAddressDropdownEndpoint, false);
  }

  vendorQuickCreate(data: any) {
    return this.post(this.vendorQuickCreateEndpoint, data);
  }

  vendorQuickUpdate(data: any) {
    return this.put(this.vendorQuickCreateEndpoint + `${data.id}/`, data);
  }

  importBucket(formData) {
    return this.postSimple(this.importBucketEndPoint, formData);
  }

  importBucketUser(formData) {
    return this.post(this.importBucketUserEndPoint, formData, true);
  }

  downloadBucketUserTemplate() {
    return this.getBlob(this.importBucketUserTemplateEndPoint, true);
  }

  reduceMoneyRequest(id, data) {
    return this.put(this.partialMoneyRequest + `${id}/`, data, true);
  }

  updateInReportMatrix(value, status) {
    if (status == 'S') {
      const payload = {
        "document_id": value.id,
        "document_type": "REPORT",
      };
      return this.post(this.submitForApprovalEndpoint, payload, true);
    }
    else if (status == 'A' || status == 'V') {
      const payload = {
        "document_id": value.id,
        "document_type": "REPORT",
      };
      return this.post(this.processApprovalRequestEndpoint, payload, true);
    } else if (status == 'R') {
      const payload = {
        "document_id": value.id,
        "document_type": "REPORT",
        "remarks": value.reason
      };
      return this.post(this.rejectApprovalRequestEndpoint, payload, true);
    }
  }


  // Trip Approvals Endpoints
  updateInTripMatrix(value, status) {
    if (status == 'S') {
      const payload = {
        "document_id": value.id,
        "document_type": "TRIP",
      };
      return this.post(this.submitForApprovalEndpoint, payload, true);
    }
    else if (status == 'A' || status == 'V') {
      const payload = {
        "document_id": value.id,
        "document_type": "TRIP",
      };
      return this.post(this.processApprovalRequestEndpoint, payload, true);
    } else if (status == 'R') {
      const payload = {
        "document_id": value.id,
        "document_type": "TRIP",
        "remarks": value.reason
      };
      return this.post(this.rejectApprovalRequestEndpoint, payload, true);
    }
  }

  // Credits Reversals Approvals Endpoints
  updateInCreditsMatrix(value, status) {
    if (status == 'S') {
      const payload = {
        "document_id": value.id,
        "document_type": "UNADJUSTED_CREDIT",
      };
      return this.post(this.submitForApprovalEndpoint, payload, true);
    }
    else if (status == 'A' || status == 'V') {
      const payload = {
        "document_id": value.id,
        "document_type": "UNADJUSTED_CREDIT",
      };
      return this.post(this.processApprovalRequestEndpoint, payload, true);
    } else if (status == 'R' || status == 'X') {
      const payload = {
        "document_id": value.id,
        "document_type": "UNADJUSTED_CREDIT",
        "remarks": value.reason
      };
      return this.post(this.rejectApprovalRequestEndpoint, payload, true);
    }
  }
}
